export const en = {
  common: {
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    cancel: 'Cancel',
    confirm: 'Confirm',
    save: 'Save',
    close: 'Close',
    logout: 'Logout',
    submit: 'Submit',
    back: 'Back',
    retry: 'Retry',
    or: 'or',
    newVersion: 'A new version of the site is available.',
    reload: 'Reload',
  },
  login: {
    subtitleSignIn: 'Sign in to your account',
    subtitleSignUp: 'Create an account',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    signIn: 'Sign in',
    signUp: 'Sign up',
    working: 'Working…',
    createAccount: 'Create an account',
    haveAccount: 'I already have an account',
  },
  welcome: {
    greeting: 'Welcome, {name}',
    signedInAs: 'You are signed in as {email}.',
    scaffoldNote: 'This is the portal-k8s scaffold. More features will be ported here over time.',
    logOut: 'Log out',
  },
  minimaxH3: {
    navTitle: 'MiniMax H3 Video',
    title: 'Best Uncensored Video Model - MiniMax H3',
    // Only the Welcome quick-action card shows this; the page itself has no subtitle.
    description: 'Text, start/end frames or reference assets in, video with native audio out.',
    startWith: 'Start with',
    modeText: 'Text only',
    modeFrames: 'Start/End frames',
    modeRefs: 'Reference assets',
    startFrame: 'Start frame',
    endFrame: 'End frame',
    required: 'Required',
    optional: 'Optional',
    refImages: 'Reference images (up to 9)',
    refVideo: 'Reference video (up to 1)',
    refAudio: 'Reference audio (up to 3)',
    clear: 'Clear',
    prompt: 'Prompt',
    promptRequired: '(Required)',
    promptPlaceholder: 'Describe your video — the scene, camera, sounds and music, with any dialogue in quotes.',
    settings: 'Options',
    aspectRatio: 'Aspect ratio',
    aspectAuto: 'Auto (match input)',
    resolution: 'Resolution',
    duration: 'Duration',
    qualityMode: 'Quality Mode',
    qualitySurcharge: '(+{credits} credit/sec)',
    generate: 'Generate',
    resultTitle: 'Your video',
    newGeneration: 'New generation',
    keyframes: 'Keyframes',
    keyframesHint: 'Pin a still to an exact moment inside the clip. Up to 3 recommended.',
    keyframeLabel: 'Keyframe {n}',
    keyframeTime: 'Time (s)',
    addKeyframe: 'Add keyframe',
    removeKeyframe: 'Remove keyframe {n}',
    keyframeNeedsImage: 'Add an image or remove this keyframe',
    keyframeBadTime: 'Enter a time in seconds',
    keyframeOutside: 'Must be inside the clip: after 0 s and before {max} s',
    keyframeSameFrame: 'Same frame as keyframe {n}',
    keyframesMany: 'More than 3 keyframes can make the motion stiff.',
  },
  ltxVideo: {
    navTitle: 'LTX 2.3 Video',
    title: 'LTX 2.3 Video Generation',
    description: 'Generate a video from a text prompt. Optionally guide it with a starting frame (and an ending frame).',
    firstFrame: 'First frame',
    lastFrame: 'Last frame (optional)',
    prompt: 'Prompt',
    promptPlaceholder: 'Describe the video you want to create…',
    duration: 'Duration',
    resolution: 'Resolution',
    aspectRatio: 'Aspect ratio',
    aspectLockedHint: 'Locked to the starting frame',
    forceNsfw: 'Force to Optimize for NSFW',
    forceNsfwHint: 'Optimize the pipeline for NSFW content',
    generate: 'Generate',
    queuedMessage: 'Your generation has been queued. It typically completes in 2–5 minutes.',
    viewInHistory: 'View in History',
    newGeneration: 'New generation',
  },
  wan22Video: {
    navTitle: 'Wan 2.2 Video',
    title: 'Wan 2.2 Video Generation',
    description: 'Text-to-video, or image-to-video when a first frame is provided. Fixed 5-second clips.',
    framesTitle: 'Frames (optional)',
    framesDescription: 'Provide a first frame to anchor image-to-video. Last frame is optional.',
    firstFrame: 'First frame',
    lastFrame: 'Last frame',
    modeLabel: 'Mode',
    prompt: 'Prompt',
    promptPlaceholder: 'Describe the video you want to create…',
    settings: 'Settings',
    resolution: 'Resolution',
    aspectRatio: 'Aspect ratio',
    aspectLockedHint: 'Locked to the starting frame',
    forceNsfw: 'Force NSFW',
    forceNsfwHint: 'Optimize the pipeline for NSFW content',
    generate: 'Generate',
    resultTitle: 'Result',
    newGeneration: 'New generation',
  },
  videoAddSound: {
    navTitle: 'Video Add Sound',
    title: 'Add Sound to Video',
    description: 'Add AI-generated sound effects and ambience to an existing video, guided by a prompt.',
    inputVideo: 'Input video',
    supportedFormats: 'Choose video (MP4, MOV, WebM, AVI, MKV)',
    prompt: 'Sound prompt',
    promptPlaceholder: 'Describe the sounds you want to add…',
    generate: 'Add Sound',
    newGeneration: 'New generation',
  },
  ltxVideoExtend: {
    navTitle: 'Video Extension',
    title: 'LTX Video Extension',
    description: 'Continue an existing video seamlessly. Upload a clip, describe what should happen next, and LTX-2.3 generates new frames and audio that follow the input.',
    inputVideo: 'Input video',
    supportedFormats: 'Choose video (MP4, MOV, WebM, AVI, MKV)',
    prompt: 'Continuation prompt',
    promptPlaceholder: 'Describe what should happen in the extended portion…',
    settings: 'Settings',
    modelLabel: 'Model tier',
    modelStandard: 'Standard',
    modelPro: 'Pro',
    modelPremium: 'Premium',
    resolutionLabel: 'Resolution',
    durationLabel: 'Extend by',
    generate: 'Extend Video',
    resultTitle: 'Result',
    newGeneration: 'New generation',
  },
  imageEdit: {
    navTitle: 'Image Edit',
    title: 'Image Edit',
    description: 'Edit one or more input images with a prompt. Pick a model that fits the use case.',
    modelTitle: 'Model',
    model: 'Model',
    aspectRatio: 'Aspect ratio',
    resolution: 'Resolution',
    imagesTitle: 'Input images',
    imagesDescription: 'Image 1 is required. Images 2 and 3 are optional and used by some models.',
    image1: 'Image 1',
    image2: 'Image 2 (optional)',
    image3: 'Image 3 (optional)',
    prompt: 'Prompt',
    promptPlaceholder: 'Describe the edit you want to make…',
    generate: 'Generate',
    resultTitle: 'Result',
    newGeneration: 'New edit',
  },
  multiAngle: {
    navTitle: 'Multi-Angle View',
    title: 'Multi-Angle View',
    description: 'Generate multiple views of a single image from different angles — azimuth, elevation, and distance.',
    inputImage: 'Input image',
    angleSelection: 'Angle selection',
    angleHint: 'Leave a dimension empty to include all of its options.',
    azimuth: 'Azimuth',
    elevation: 'Elevation',
    distance: 'Distance',
    willGenerate: 'Will generate ~{count} images',
    generate: 'Generate',
    resultTitle: 'Result',
    newGeneration: 'New generation',
  },
  faceSwap: {
    navTitle: 'Face Swap',
    title: 'Face Swap',
    description: 'Swap a reference face onto a base body image. Upload one base image and one or more reference faces.',
    imagesTitle: 'Input images',
    imagesDescription: 'The base body image and the first reference face are required. Add up to two more reference faces.',
    baseImage: 'Base body image',
    referenceFace1: 'Reference face 1',
    referenceFace2: 'Reference face 2 (optional)',
    referenceFace3: 'Reference face 3 (optional)',
    addExtraFaces: 'Add more reference faces',
    hideExtraFaces: 'Hide extra reference faces',
    generate: 'Generate',
    resultTitle: 'Result',
    newGeneration: 'New face swap',
  },
  textToImage: {
    navTitle: 'Text to Image',
    title: 'Text to Image',
    description: 'Generate images from a text prompt. Pick a model that fits the use case.',
    modelTitle: 'Model',
    model: 'Model',
    aspectRatio: 'Aspect ratio',
    resolution: 'Resolution',
    numImages: 'Images',
    prompt: 'Prompt',
    promptPlaceholder: 'Describe the image you want to create…',
    generate: 'Generate',
    resultTitle: 'Result',
    newGeneration: 'New image',
  },
  humanPortrait: {
    navTitle: 'Human Portrait',
    title: 'Human Portrait',
    description: 'Generate a base virtual-human portrait. Dial in appearance traits — leave any field on Random to let the model decide.',
    outputTitle: 'Output settings',
    gender: 'Gender',
    age: 'Age',
    aspectRatio: 'Aspect ratio',
    resolution: 'Resolution',
    batchSize: 'Batch size',
    characterTitle: 'Character traits',
    characterHint: 'Default = let the model decide (no randomization). Randomize = pick a varied value from the list.',
    optDefault: 'Default',
    optRandomize: '🎲 Randomize',
    promptTitle: 'Prompt prefix (optional)',
    promptHint: 'Free text prepended to the prompt — e.g. clothing, expression, scene.',
    promptPlaceholder: 'e.g. wearing a red dress, smiling, studio lighting…',
    generate: 'Generate',
    resultTitle: 'Result',
    newGeneration: 'New portrait',
  },
  instagramGenerator: {
    navTitle: 'Instagram Photo',
    title: 'Instagram Photo Generator',
    description: 'Turn one photo of your main character into an Instagram-style shot in any scene you describe, keeping their face and identity intact.',
    mainCharacter: 'Main character',
    mainCharacterDescription: 'Upload one photo of the person. Their facial identity, hairstyle and features are preserved in the output.',
    outputTitle: 'Output settings',
    aspectRatio: 'Aspect ratio',
    quality: 'Quality',
    batchSize: 'Number of photos',
    prompt: 'Scene prompt',
    promptPlaceholder: 'Describe the scene, pose, outfit and setting… e.g. dancing in a sunlit park, wearing a denim jacket',
    enrichPrompt: 'Enrich prompt with extra detail',
    enrichPromptHint: 'When on, a vision model expands your prompt with photographic detail (lighting, wardrobe, mood, framing) before generation.',
    generate: 'Generate',
    resultTitle: 'Result',
    newGeneration: 'New photo',
  },
  videoFaceSwap: {
    navTitle: 'Video Face Swap',
    title: 'Video Face Swap',
    description: 'Swap the head from a reference photo onto the person in a video. No prompt needed — just upload a face and a video.',
    headImage: 'Head reference',
    headImageDescription: 'The photo whose face and head will be placed onto the person in the video.',
    bodyVideo: 'Body video',
    bodyVideoDescription: 'The video whose subject gets the new head.',
    supportedFormats: 'Choose video (MP4, MOV, WebM, AVI, MKV)',
    generate: 'Swap Face',
    resultTitle: 'Your video',
    newGeneration: 'New face swap',
  },
  credits: {
    navTitle: 'Credits',
    title: 'Credits',
    description: 'Your balance and credit history. 1 credit = $0.01.',
    balance: 'Balance',
    balanceUnit: 'credits',
    usdEquivalent: '≈ ${value} USD',
    getMore: 'Get more credits',
    historyTitle: 'Credit history',
    historyEmpty: 'No credit activity yet.',
    historyEmptyFiltered: 'No credit activity in this time range.',
    filter: {
      label: 'Time range',
      all: 'All time',
      last7: 'Last 7 days',
      last30: 'Last 30 days',
      last90: 'Last 90 days',
      custom: 'Custom',
      from: 'From',
      to: 'To',
    },
    pagination: {
      rowsPerPage: 'Rows per page:',
      displayed: '{from}–{to} of {count}',
    },
    table: {
      when: 'When',
      reason: 'Reason',
      endpoint: 'Endpoint',
      delta: 'Change',
      balance: 'Balance',
      note: 'Note',
    },
    reasonLabels: {
      usage: 'Usage',
      refund: 'Refund',
      admin_grant: 'Granted',
      purchase: 'Purchase',
      adjustment: 'Adjustment',
    },
  },
  payment: {
    navTitle: 'Payment',
    title: 'Buy credits',
    description: 'Top up your account with crypto. Settles automatically once the payment is confirmed on-chain.',
    packagesTitle: 'Pick a package',
    customTitle: 'Or choose a custom amount',
    customLabel: 'USD amount',
    customMin: 'Minimum $5.',
    creditsLabel: 'credits',
    bestValue: 'Best value',
    payButton: 'Pay with crypto',
    submitting: 'Creating invoice…',
    invoiceCreated: 'Redirecting to checkout…',
    successBanner: 'Thanks! We\'ll credit your account once the payment is confirmed.',
    cancelBanner: 'Payment cancelled. Nothing was charged.',
    historyTitle: 'Recent invoices',
    historyEmpty: 'No payments yet.',
    statusLabels: {
      created: 'Created',
      waiting: 'Waiting',
      confirming: 'Confirming',
      confirmed: 'Confirmed',
      sending: 'Sending',
      partially_paid: 'Partially paid',
      finished: 'Finished',
      failed: 'Failed',
      refunded: 'Refunded',
      expired: 'Expired',
    },
    openInvoice: 'Open invoice',
    emailReminderTitle: 'Add an email to protect your account',
    emailReminderBody:
      'You signed up without an email. Without one you won\'t be able to recover your password if you lose access. We strongly recommend adding and verifying an email before topping up.',
    emailReminderLink: 'Manage account',
  },
  changePassword: {
    navTitle: 'Change Password',
    title: 'Change Password',
    description: 'Update the password you use to sign in.',
    oldPassword: 'Current password',
    newPassword: 'New password',
    confirmPassword: 'Confirm new password',
    submit: 'Update password',
    success: 'Password updated.',
    errors: {
      mismatch: 'New passwords do not match.',
      tooShort: 'Password must be at least 8 characters.',
      generic: 'Could not update password.',
    },
  },
  apiKeys: {
    navTitle: 'API Keys',
    docsNav: 'API Docs',
    title: 'API Keys',
    description: 'Keys let your own code call the video agent API. Requests are billed to your credits like anything you generate here.',
    nameLabel: 'Key name',
    namePlaceholder: 'e.g. production server',
    create: 'Create key',
    empty: 'No API keys yet.',
    createdOn: 'Created {date}',
    lastUsed: 'last used {date}',
    neverUsed: 'never used',
    usage: '{count} of {max} keys in use',
    createdTitle: 'Your new API key',
    createdBody: 'Copy it now. For your security it is shown only once and we cannot show it again.',
    keyLabel: 'API key',
    copy: 'Copy',
    copied: 'Copied',
    done: 'I have copied it',
    revoke: 'Revoke',
    revokeTitle: 'Revoke this key?',
    revokeBody: 'Anything using "{name}" will stop working immediately. This cannot be undone.',
    errors: {
      load: 'Could not load your API keys.',
      create: 'Could not create the key.',
      revoke: 'Could not revoke the key.',
      limit: 'You already have {max} active keys. Revoke one first.',
      rateLimited: 'Too many keys created. Try again later.',
    },
  },
  recoveryEmail: {
    navTitle: 'Recovery Email',
    title: 'Recovery Email',
    description:
      'The email used to recover your account if you lose your password. Changing it requires confirming a code we send to the new address.',
    currentLabel: 'Current email',
    notSet: 'Not set',
    currentPassword: 'Current password',
    newEmail: 'New email',
    sendCode: 'Send verification code',
    codeSent: 'We sent a 6-digit code to your new email.',
    codeInstructions: 'Enter the 6-digit code we sent to {email} to confirm the change.',
    code: 'Verification code',
    verify: 'Confirm new email',
    updated: 'Recovery email updated.',
    errors: {
      generic: 'Could not update recovery email.',
    },
  },
  support: {
    navTitle: 'Support',
    title: 'Support',
    description: 'Need help? Send us a message and we\'ll get back to you.',
    body: 'We typically respond within one business day.',
    emailButton: 'Email',
  },
  videoAgent: {
    navTitle: 'Video Agent',
    title: 'Video Agent',
    intro: "Hi! I'm your video director. Tell me what you want to make and I'll help you plan it, get the length right and write a prompt that works — you approve every generation and see the price first.",
    startFromImage: 'Create a video from an image',
    startFromImageHint: 'Upload a photo or picture and bring it to life',
    startFromText: 'Create a video from a description',
    startFromTextHint: 'Describe a scene, a story or an ad',
    startImagesFirst: 'Create images first',
    startImagesFirstHint: 'Design the first frame, then animate it',
    placeholder: 'Describe your video, paste a script, or ask anything…',
    attach: 'Attach image, audio or video',
    send: 'Send',
    newChat: 'New chat',
    chats: 'Chats',
    noChats: 'No chats yet',
    deleteChat: 'Delete chat',
    apiRun: 'API',
    apiRunReadOnly: 'This run was started through the API, so it is read-only. Start a new chat to keep working on it.',
    chatActions: 'Chat actions',
    untitled: 'New chat',
    thinking: 'Thinking…',
    showThinking: 'Show reasoning',
    uploading: 'Uploading…',
    tooManyFiles: 'You can attach up to {max} files per message.',
    makingSheet: 'Making a reference sheet…',
    referenceSheet: 'Reference sheet · {subject}',
    references: 'References',
    confirm: 'Generate · {credits} credits',
    cancel: 'Not now',
    editPrompt: 'Edit prompt',
    hidePrompt: 'Hide prompt',
    writingPrompt: 'Writing the prompt in the official MiniMax H3 format…',
    h3SkillNote: 'Prompt written in the official MiniMax H3 format (h3-prompt-writing)',
    duration: 'Duration',
    tier: 'Quality',
    tierQuality: 'Quality',
    tierTurbo: 'Turbo (faster)',
    confirmed: 'Submitted',
    dismissed: 'Dismissed',
    rendering: 'Rendering…',
    queued: 'Queued…',
    failed: 'Generation failed',
    animate: 'Animate this image',
    editImage: 'Edit this image',
    useAsFrame: 'Use as first frame',
    download: 'Download',
    planCheck: 'Plan check: needs ~{need}s · recommended {rec}s',
    buyCredits: 'Buy credits',
    error: 'Something went wrong: {error}',
    busy: 'Still working on the previous message…',
    retry: 'Retry',
    retrying: 'Retrying…',
    errorDetails: 'Details',
    errTurn: 'The assistant couldn’t finish that reply.',
    errTimeout: 'The assistant took too long to answer.',
    errNetwork: 'The connection dropped before the reply finished.',
    errSubmit: 'The generation couldn’t be submitted.',
    errRejected: 'The video service rejected this request. You can retry, or edit the prompt first.',
    errContentMinor:
      'The content check stopped this: the prompt, your images or the video it would make may show a minor (someone under 18). No credits were charged. Revise the plan or the images so everyone is clearly an adult.',
    errContentExplicit:
      'The content check stopped this: the prompt, your images or the video it would make were judged sexually explicit. No credits were charged. Revise the plan or the images.',
    reviseWithAgent: 'Ask the agent to revise',
    reviseRejected: 'The content check rejected that video. Please revise the plan so it passes, then propose it again.',
    errService: 'The generation service had a problem. Nothing was charged — please try again.',
    errBusy: 'Another reply or submission is still running in this chat. Try again in a moment.',
    errCredits: 'Not enough credits for this generation.',
    errSignup: 'Please sign up to generate.',
    jobDone: 'Ready',
    queuePosition: '#{n} in queue',
    etaLeft: 'about {min} min left',
    etaAlmost: 'almost done',
    elapsed: '{time} elapsed',
    typicalVideo: 'videos usually take 3–15 min',
    typicalImage: 'images usually take under a minute',
    leaveNoteVideo: 'You can leave this page — the video keeps rendering and will appear here when you come back.',
    leaveNoteImage: 'You can leave this page — the image keeps rendering and will appear here when you come back.',
    statusUnavailable: 'Could not load the status ({error}). Check History for this generation.',
    jobsRunning: '{n} rendering',
    jobReadyVideo: 'Your video is ready',
    jobReadyImage: 'Your image is ready',
    jobFailedNotice: 'A generation failed',
  },
  history: {
    navTitle: 'History',
    title: 'Generation History',
    description: 'Your past generations across every feature. Items refresh automatically while jobs are running.',
    empty: 'No generations yet.',
    deleteConfirm: 'Delete this generation? This cannot be undone.',
    table: {
      createdAt: 'Created',
      feature: 'Feature',
      model: 'Model',
      status: 'Status',
      credits: 'Credits',
    },
    status: {
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
    },
    detail: {
      noSelection: 'Select a row to see details.',
      requestId: 'Request ID',
      createdAt: 'Created at',
      credits: 'Credits used',
      prompt: 'Prompt',
      download: 'Download',
      inProgress: 'Job is still running. The page will update automatically.',
      retry: 'Retry',
      retryTooltip:
        'Re-runs this generation with the original inputs. Uploaded inputs may be deleted after 30 days — the retry will fail in that case.',
      retrying: 'Submitting…',
      retrySuccess: 'Retry queued — check the new row at the top.',
      retryInputsExpired: 'Cannot retry: original inputs were deleted (older than 30 days).',
      rerun: 'Rerun',
      rerunTooltip: 'Re-run with the original inputs — deducts credits again.',
      remix: 'Remix…',
      remixTooltip: 'Open the form with the original settings pre-filled. No credits charged until you submit.',
      jobId: 'Job',
      batchJobId: 'Backend job',
      copyPrompt: 'Copy prompt',
      copied: 'Copied!',
      originalPrompt: 'Original prompt',
      enhancedPrompt: 'Enhanced prompt',
      close: 'Close',
    },
  },
  landing: {
    signIn: 'Sign in',
    signUp: 'Sign up',
    heroTitle: 'Free Uncensored AI Video Generator',
    heroSubtitle: 'Open-source video models at the core. Realizing truthfully to your imagination.',
    promoBanner: '🎁 Sign up free — get {signup} credits · Verify your email for +{email} more',
    tabImageToVideo: 'Image to Video',
    tabTextToVideo: 'Text to Video',
    uploadLabel: 'Click or drop an image',
    uploadHint: 'JPEG, PNG or WebP',
    changeImage: 'Change image',
    removeImage: 'Remove',
    promptLabel: 'Prompt',
    promptPlaceholderI2v: 'Describe how the image should come to life…',
    promptPlaceholderT2v: 'Describe the video you want to create…',
    duration: 'Duration',
    seconds: '{n}s',
    generate: 'Generate video',
    promptRequired: 'Write a short prompt first',
    imageRequired: 'Pick an image first',
    useCasesTitle: 'What will you make?',
    useCase1Title: 'Bring photos to life',
    useCase1Body: 'Turn any image into smooth, realistic motion with image-to-video generation.',
    useCase2Title: 'Imagine from scratch',
    useCase2Body: 'Type a prompt and get a fully generated video clip — no source material needed.',
    useCase3Title: 'A full creative toolkit',
    useCase3Body: 'Edit images, swap faces, upscale, add sound, and more — all in one place.',
    featuresTitle: 'Everything you can make',
    featuresSubtitle: 'Eleven generation tools, powered by state-of-the-art open-source models.',
    featureCta: 'Try it',
    footerModels: 'LTX 2.3 & Wan 2.2 — state-of-the-art open video models, hosted and ready.',
    footerOpenSource: 'Open-source core — no black boxes, built on community model weights.',
    footerUncensored: 'Uncensored — generate what you actually want to see.',
  },
  signupNudge: {
    title: 'Get free credits',
    subtitle: 'Create your account to start generating',
    benefitSignup: 'Complete sign up — get {credits} free credits',
    benefitEmail: 'Verify your email — get {credits} more',
    signUp: 'Sign up free',
    signIn: 'I already have an account',
    continueWithout: 'Continue without an account',
    guestWorking: 'Setting up guest access…',
    guestError: 'Could not start a guest session. Please try again.',
  },
  emailPromo: {
    cardTitle: 'Claim {credits} free credits',
    cardBody: 'Add and verify your email address to claim a one-time bonus of {credits} credits.',
    emailLabel: 'Email address',
    sendCode: 'Send code',
    sending: 'Sending…',
    codeLabel: 'Verification code',
    codeHint: 'Enter the 6-digit code we sent to {email}',
    confirm: 'Verify & claim',
    confirming: 'Verifying…',
    success: '{credits} credits added to your balance!',
    alreadyClaimed: 'This bonus was already claimed.',
    bannerText: 'Verify your email and get {credits} free credits',
    bannerCta: 'Claim now',
    guestBannerText: 'You are browsing as a guest — sign up to get free credits',
    guestBannerCta: 'Get credits',
    errorSend: 'Could not send the code. Check the address and try again.',
    errorVerify: 'Invalid or expired code.',
  },
  adminUsers: {
    navTitle: 'Users',
    title: 'Users',
    description: 'All registered users and their credit balances.',
    loadError: 'Failed to load users ({status})',
    requestFailed: 'Request failed ({status})',
    userFallback: 'User #{id}',
    empty: 'No users yet.',
    table: {
      user: 'User',
      role: 'Role',
      credits: 'Credits',
      jobs: 'Jobs',
      spent: 'Spent',
      lastLogin: 'Last login',
    },
    dialog: {
      title: 'Adjust credits',
      balance: '{who} — current balance {credits} credits',
      add: 'Add',
      setTo: 'Set to',
      amount: 'Credits',
      helperAdd: 'Credits to grant on top of the balance.',
      helperSet: 'New total balance.',
      amountError: 'Amount must be a whole number of credits.',
    },
  },
  adminPricing: {
    navTitle: 'Pricing',
    title: 'Pricing',
    description: 'Credit cost per feature. Changes take effect within a minute (prices are cached briefly).',
    addPrice: 'Add price',
    any: 'any',
    empty: 'No pricing rows yet.',
    editCredits: 'Edit credits',
    delete: 'Delete',
    deleteConfirm: 'Delete the {endpoint} price? This cannot be undone.',
    loadError: 'Failed to load pricing ({status})',
    deleteFailed: 'Delete failed ({status})',
    requestFailed: 'Request failed ({status})',
    table: {
      endpoint: 'Endpoint',
      model: 'Model',
      resolution: 'Resolution',
      duration: 'Duration',
      credits: 'Credits',
      actions: 'Actions',
    },
    dialog: {
      editTitle: 'Edit price',
      addTitle: 'Add price',
      intro: 'A price is keyed by endpoint × model × resolution × duration. Use * for any. Lookup picks the most specific match. The value is the per-unit base rate — some endpoints multiply it (per image, per 5s, per num_images).',
      endpoint: 'Endpoint',
      endpointPlaceholder: 'e.g. ltx-video-extend',
      endpointHelperAdd: 'The feature key, e.g. minimax-h3.',
      endpointHelperEdit: 'Delete and re-add to change the key.',
      model: 'Model',
      resolution: 'Resolution',
      resolutionPlaceholder: '720p / *',
      duration: 'Duration',
      durationPlaceholder: '5s / *',
      credits: 'Credits',
      creditsHelper: 'Base rate in credits (1 credit = $0.01).',
      endpointRequired: 'Endpoint is required.',
      creditsInvalid: 'Credits must be a non-negative whole number.',
    },
  },
  videoShares: {
    navTitle: 'Video shares',
    title: 'Video shares',
    description: 'Upload a video and hand out a public link that plays it in the browser. Select several to line them up on one page.',
    groupShare: 'Group share',
    groupShareCount: 'Group share ({count})',
    clearSelection: 'Clear selection',
    shareMore: 'Share more…',
    selectAll: 'select all videos',
    selectOne: 'select {title}',
    deleteOne: 'delete {title}',
    deleteGroupOne: 'delete group {title}',
    empty: 'Nothing shared yet. Use “Share more…” to upload a video.',
    deleteVideo: 'Delete upload (disables the link)',
    deleteVideoConfirm: 'Delete "{title}"? The file is removed from storage and its link stops working immediately.',
    groupsTitle: 'Group shares',
    groupsDescription: 'One page, several videos.',
    groupsEmpty: 'No group links yet. Tick videos above and press “Group share”.',
    deleteGroup: 'Delete group link',
    deleteGroupConfirm: 'Delete the group link "{title}"? The videos themselves stay shared.',
    videoCount: '{count} video',
    videosCount: '{count} videos',
    layoutAuto: 'Auto (fit the screen)',
    layoutAutoShort: 'auto',
    perRow: '{n} per row',
    copyLink: 'Copy link',
    open: 'Open',
    copy: 'Copy',
    copied: 'Copied',
    linkCopied: 'Link copied',
    copyFailed: 'Could not copy — select the link and copy it manually',
    expired: 'expired',
    noExpiry: 'No expiry',
    linkExpires: 'Link expires',
    table: {
      video: 'Video',
      size: 'Size',
      shared: 'Shared',
      expires: 'Expires',
      link: 'Link',
    },
    groupTable: {
      group: 'Group',
      videos: 'Videos',
      layout: 'Layout',
      created: 'Created',
      expires: 'Expires',
      link: 'Link',
    },
    ttl: {
      oneHour: '1 hour',
      oneDay: '1 day',
      days7: '7 days',
      days30: '30 days',
      days90: '90 days',
      never: 'Never',
    },
    expiry: {
      never: 'never',
      expired: 'expired',
      inMinutes: 'in {n} min',
      inHours: 'in {n} h',
      inDays: 'in {n} days',
    },
    upload: {
      title: 'Share videos',
      intro: 'Each file becomes its own public link. Large files upload in 16 MB slices, so keep this tab open until every row shows a link.',
      choose: 'Choose videos…',
      titleLabel: 'Title',
      tooLarge: 'larger than {max}',
      done: 'Done',
      upload: 'Upload',
      uploadCount: 'Upload {count}',
    },
    group: {
      title: 'Group share',
      intro: 'One link that lines these {count} videos up on a single page, in the order below. The group has its own expiry; a video that expires or is deleted drops off the page.',
      titleLabel: 'Title',
      layout: 'Layout',
      defaultTitle: '{count} videos',
      done: 'Done',
      create: 'Create link',
    },
  },
  sharedView: {
    linkExpires: 'Link expires {when}',
    sharedLink: 'Shared link',
    missingTitle: 'This link doesn’t exist',
    missingBody: 'Check the address, or ask whoever sent it for a new link.',
    expiredTitle: 'This link has expired',
    expiredBody: 'The share has reached the end of its lifetime. Ask whoever sent it for a new link.',
    errorTitle: 'Something went wrong',
    requestFailed: 'Request failed ({status})',
    emptyTitle: 'Nothing to show',
    emptyBody: 'Every video in this share has expired or been removed.',
  },
};

export type TranslationKeys = typeof en;
